import { ref, uploadBytes, getDownloadURL, deleteObject, getBlob } from 'firebase/storage';
import { storage } from '../config/firebase';

export const uploadImage = async (file: File | Blob, customFilename?: string): Promise<{ filename: string; size: number }> => {
  try {
    const filename = customFilename || (file instanceof File ? file.name : `image_${Date.now()}.jpg`);
    // Use the original filename in storage root
    const storageRef = ref(storage, filename);

    // Upload the file
    const snapshot = await uploadBytes(storageRef, file);

    // Get the download URL (for potential future use)
    await getDownloadURL(snapshot.ref);

    // Return the filename and size
    return {
      filename,
      size: file.size
    };
  } catch (error) {
    console.error('Error uploading image:', error);
    throw new Error('Failed to upload image to Firebase Storage');
  }
};

export const renameImage = async (oldFilename: string, newFilename: string): Promise<{ filename: string; size: number }> => {
  try {
    // Reference to the old and new file locations
    const oldRef = ref(storage, oldFilename);
    const newRef = ref(storage, newFilename);

    // Download the file as a blob
    const blob = await getBlob(oldRef);

    // Upload the blob to the new location
    await uploadBytes(newRef, blob);

    // Delete the old file
    await deleteObject(oldRef);

    // Return the new filename and size
    return {
      filename: newFilename,
      size: blob.size
    };
  } catch (error) {
    console.error('Error renaming image:', error);
    throw new Error('Failed to rename image in Firebase Storage');
  }
};

export const deleteImage = async (filename: string): Promise<void> => {
  await deleteObject(ref(storage, filename));
};
